import { useAllKitties } from './useAllKitties';
import { useKittiesStore } from './useKittiesStore';

const getUniqueTraits = (kitties, generation, checkIfUserOwnsKitty) => {
  const traits = kitties.filter((kitty) => kitty.gen === generation).flatMap((kitty) => kitty.attributes);

  const groupedTraits = traits.reduce((acc, trait) => {
    acc[trait.trait_type] = (acc[trait.trait_type] || []).concat(trait.value);
    return acc;
  }, {});

  return Object.keys(groupedTraits)
    .map((traitType) => ({
      trait_type: traitType,
      values: [...new Set(groupedTraits[traitType])]
        .filter((value) => value !== 'None')
        .filter((value) => value !== 'Nothing')
        .filter((value) => (generation === 4 && value !== 'Crown') || (generation !== 4 && value !== 'Crown'))
        .sort()
        .map((value) => ({ value, owned: checkIfUserOwnsKitty(traitType, value, generation), traitType, generation })),
    }))
    .sort((a, b) => a.trait_type.localeCompare(b.trait_type));
};

export const useUserTraits = (kitties) => {
  const { allKitties } = useAllKitties();
  const { myKitties } = useKittiesStore();
  const kittiesToCheck = kitties || myKitties;

  const checkIfUserOwnsKitty = (traitType, value, generation) => {
    return kittiesToCheck
      .filter((kitty) => kitty.gen === generation)
      .some((kitty) => kitty.attributes.some((attribute) => attribute.trait_type === traitType && attribute.value === value));
  };

  const firstLitterTraits = getUniqueTraits(allKitties, 1, checkIfUserOwnsKitty);
  const secondLitterTraits = getUniqueTraits(allKitties, 2, checkIfUserOwnsKitty);
  const thirdLitterTraits = getUniqueTraits(allKitties, 3, checkIfUserOwnsKitty);
  const fourthLitterTraits = getUniqueTraits(allKitties, 4, checkIfUserOwnsKitty);

  const allTraits = [
    ...firstLitterTraits.flatMap((value) => value.values),
    ...secondLitterTraits.flatMap((value) => value.values),
    ...thirdLitterTraits.flatMap((value) => value.values),
    ...fourthLitterTraits.flatMap((value) => value.values),
  ];
  const ownedTraits = allTraits.filter((trait) => trait.owned);
  const totalOwnedTraits = ownedTraits.length;

  return {
    traits: {
      firstLitter: firstLitterTraits,
      secondLitter: secondLitterTraits,
      thirdLitter: thirdLitterTraits,
      fourthLitter: fourthLitterTraits,
    },
    allTraits,
    ownedTraits,
    totalOwnedTraits,
  };
};
